<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.product')"
    resource="products"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { abilityService } from 'beans-admin-plugin';

@Component
export default class Products extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('product.name'),
        renderCell: {
          component: 'input'
         }
      },
      {
        prop: 'en_name_cont',
        label: this.$t('product.enName'),
        renderCell: {
          component: 'input'
         }
      },
      this.$root.user.current_role.role.kind !== 'merchant' && {
        prop: 'merchant_id_eq',
        label: this.$t('model.merchant'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchants', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchants', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      }
    ].filter(Boolean)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'main_image',
        label: this.$t('product.mainImage'),
        width: 120,
        renderCell: 'storageAttachment',
      },
      {
        prop: 'name',
        label: this.$t('product.name'),
      },
      {
        prop: 'en_name',
        label: this.$t('product.enName'),
      },
      type === 'show' && {
        prop: 'alcohol_content',
        label: this.$t('product.alcoholContent'),
      },
      type === 'show' && {
        prop: 'colour_and_lustre',
        label: this.$t('product.colourAndLustre'),
      },
      type === 'show' && {
        prop: 'drink_temperature',
        label: this.$t('product.drinkTemperature'),
      },
      this.$root.user.current_role.role.kind !== 'merchant' && {
        prop: 'merchant_id',
        label: this.$t('model.merchant'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.merchant) {
            const name = row.merchant.name
            if (abilityService.can('merchants.read')) {
              return <router-link to={{ name: 'merchants.show', params: { id: row.merchant_id } }}>{name}</router-link>
            } else {
              return <span>{name}</span>
            }
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'product_category_id',
        label: this.$t('model.productCategory'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.product_category) {
            const name = row.product_category.name
            if (abilityService.can('product_categories.read')) {
              return <router-link to={{ name: 'product_categories.show', params: { id: row.product_category_id } }}>{name}</router-link>
            } else {
              return <span>{name}</span>
            }
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'product_rating_id',
        label: this.$t('model.productRating'),
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.product_rating) {
            const name = row.product_rating.name
            if (abilityService.can('product_ratings.read')) {
              return <router-link to={{ name: 'product_ratings.show', params: { id: row.product_rating_id } }}>{name}</router-link>
            } else {
              return <span>{name}</span>
            }
          } else {
            return <span>/</span>
          }
        },
      },
      {
        prop: 'likes_count',
        label: this.$t('product.likesCount'),
      },
      type === 'show' && {
        prop: 'mini_program_path',
        label: this.$t('product.miniProgramPath'),
      },
      type === 'show' && {
        prop: 'background_image',
        label: this.$t('product.backgroundImage'),
        width: 120,
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'share_desc',
        label: this.$t('product.shareDesc'),
      },
      type === 'show' && {
        prop: 'share_image',
        label: this.$t('product.shareImage'),
        width: 120,
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'poster_image',
        label: this.$t('product.posterImage'),
        renderCell: 'storageAttachment',
      },
      type === 'show' && {
        prop: 'description',
        label: this.$t('product.description'),
        action: ['hide-in-table'],
        renderCell: 'html',
      },
      type === 'show' && {
        prop: 'tasting_notes',
        label: this.$t('product.tastingNotes'),
        action: ['hide-in-table'],
        renderCell: 'html',
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
    ].filter(Boolean)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { type }) {
    return [
      {
        prop: 'main_image',
        label: this.$t('product.mainImage'),
        width: 120,
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 106x446`,
          props: {
            cropper: {
              width: 106,
              height: 446
            }
          }
        }
      },
      {
        prop: 'name',
        label: this.$t('product.name'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'en_name',
        label: this.$t('product.enName'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'alcohol_content',
        label: this.$t('product.alcoholContent'),
        renderCell: {
          required: true,
          component: 'input',
          props: {
            type: 'number'
          }
        },
      },
      {
        prop: 'colour_and_lustre',
        label: this.$t('product.colourAndLustre'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      {
        prop: 'drink_temperature',
        label: this.$t('product.drinkTemperature'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
      type === 'new' && this.$root.user.current_role.role.kind !== 'merchant' && {
        prop: 'merchant_id',
        label: this.$t('model.merchant'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/merchants', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/merchants', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
      {
        prop: 'product_category_id',
        label: this.$t('model.productCategory'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/product_categories', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/product_categories', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
      {
        prop: 'product_rating_id',
        label: this.$t('model.productRating'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/product_ratings', { params: { per_page: 100 } });
              return data.map(({ id, name }) => ({ value: id, label: name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { name_cont: keyword };
              const { data } = await this.$request.get('/product_ratings', { params });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
      {
        prop: 'background_image',
        label: this.$t('product.backgroundImage'),
        width: 120,
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 750x586`,
          props: {
            cropper: {
              width: 750,
              height: 586
            }
          }
        }
      },
      {
        prop: 'share_desc',
        label: this.$t('product.shareDesc'),
        renderCell: {
          component: 'input',
        },
      },
      {
        prop: 'share_image',
        label: this.$t('product.shareImage'),
        width: 120,
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 500:400`,
          props: {
            cropper: {
              width: 500,
              height: 400
            }
          }
        }
      },
      {
        prop: 'poster_image',
        label: this.$t('product.posterImage'),
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 600x509`,
          props: {
            cropper: {
              width: 600,
              height: 509
            }
          }
        }
      },
      {
        prop: 'description',
        label: this.$t('product.description'),
        renderCell: {
          component: 'editor',
        }
      },
      {
        prop: 'tasting_notes',
        label: this.$t('product.tastingNotes'),
        renderCell: {
          component: 'editor',
        }
      },
    ].filter(Boolean)
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'products.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'products.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/products',
    name: 'products.index',
    component: Products,
    props: {
      type: 'index',
    }
  },
  {
    path: '/products/new',
    name: 'products.new',
    component: Products,
    props: {
      type: 'new',
    }
  },
  {
    path: '/products/:id',
    name: 'products.show',
    component: Products,
    props: {
      type: 'show',
    }
  },
  {
    path: '/products/:id/edit',
    name: 'products.edit',
    component: Products,
    props: {
      type: 'edit'
    }
  }
]
</script>
